import { IEvent } from "modules/event/types";
import eventMemberApi from "modules/eventMemberList/eventMember.api";

export const checkIfEmailInvited = async (
  email: string,
  event: IEvent,
  setIsInvited: (arg: boolean) => void,
) => {
  if (email && event.isPrivate && event.id) {
    const { isSuccess, data } = await eventMemberApi.checkEmailInvited(
      event.id,
      email,
    );

    if (isSuccess) {
      setIsInvited(data.invited);
    }
  }
};
